 function injectScript(code) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.textContent = code;
  document.body.appendChild(script);
}


injectScript(`
(function () {
  if("undefined"===typeof window.WSAIO){
    window.WSAIO={};
  }
   if(document.querySelector('[name="address[phone]"]') != null){
    let dCountry = "GB";
    if (dCountry === "null" || !dCountry) {
      dCountry = "";
    } else {
      dCountry = dCountry.toUpperCase();
    }
    const countryIndex = wsaio_phonecountries.find(c => c.code === dCountry );
  
  
    let currentCountry = countryIndex; 
    document.querySelector('[name="address[phone]"]').insertAdjacentHTML('beforebegin','<img id="flagIcon" class="flag-icon" src="" alt="flag" style="display:none;">');
    document.querySelector('[name="address[phone]"]').insertAdjacentHTML('afterend', '<div id="wsaioi_formphonedropdown" class="phonecountry-dropdown"> <input type="text" id="wsaio_phonesearch" class="phonecountry-search" placeholder="Search country..."> <div id="phonecountryList"></div> </div> ' );
  
    const phoneInput = document.querySelector('.ws-registration-form--form [name="address[phone]"]');
    const flagIcon = document.getElementById("flagIcon");
    const dropdown = document.getElementById("wsaioi_formphonedropdown");
    const search = document.getElementById("wsaio_phonesearch");
    const list = document.getElementById("phonecountryList");
  
  const selected_countries_options = document.getElementById('waio--address_country');
    let selected_countries_list = [];

  if (selected_countries_options) {
     selected_countries_list = Array.from(selected_countries_options.options)
      .map(option => option.getAttribute('cc'))
      .filter(code => code !== null);
  }
    const countriesToRender =
      selected_countries_list.length === 0
        ? wsaio_phonecountries
        : wsaio_phonecountries.filter(c =>
            selected_countries_list.includes(c.code)
          );

          function populateDropdown() {
            list.innerHTML = '';
            countriesToRender.forEach(c => {
              const div = document.createElement("div");
              div.className = "wsaio_phonecountry-item";
              div.dataset.code = c.code;
              div.dataset.name = c.name.toLowerCase();
              div.dataset.dial = c.dialCode;
        
              const img = document.createElement('img');
              img.src = \`https://flagcdn.com/\${String(c.code).toLowerCase()}.svg\`;
              img.alt = c.name;
        
              const span = document.createElement('span');
              span.textContent = \`\${c.name} (+\${c.dialCode})\`;
        
              div.appendChild(img);
              div.appendChild(span);
        
              div.appendChild(img);
              div.appendChild(span);
        
              div.addEventListener('mousedown', e => e.preventDefault());
              div.addEventListener('click', () => {
                setCountry(c);
                dropdown.style.display = "none";
                setTimeout(() => phoneInput.focus(), 0);
      });
        
              list.appendChild(div);
            });
                       }
        
          function setCountry(c) {
            if (c && countriesToRender.some(ct => ct.code === c.code)) {
           currentCountry = c;
              const cC = typeof c.code === 'string' ? c.code.toLowerCase() : 'us';
              flagIcon.src = \`https://flagcdn.com/\${cC}.svg\`;
              flagIcon.alt = c.name || 'Country flag';
              flagIcon.dataset.code = c.dialCode ? \`+\${c.dialCode}\` : '';
              flagIcon.style.display = 'block';
              phoneInput.style.paddingLeft = '40px';
                  }
                     }
        
          populateDropdown();

    function reset_phone_error(){
              if(document.querySelector(".ws-registration-form--form .waio--customer-phone-error") != null){
                document.querySelectorAll(".ws-registration-form--form .waio--customer-phone-error").forEach( e => e.remove() );
        }
        }


    search.addEventListener("input", () => {
      const q = search.value.toLowerCase();
      document.querySelectorAll(".wsaio_phonecountry-item").forEach(item => {
        item.style.display = item.dataset.name.includes(q) || item.dataset.code.toLowerCase().includes(q) ? "flex" : "none";
      });
    });

    flagIcon.addEventListener("click", () => {
      dropdown.style.display = dropdown.style.display === "block" ? "none" : "block";
      search.focus();
    });


     document.querySelectorAll('.wsaio_phonecountry-item').forEach(function(e){
          e.addEventListener("click", () => {
            phoneInput.value = '';
             reset_phone_error();
        });
      })

    phoneInput.addEventListener("click", () => {
      if(flagIcon.style.display == 'none'){
                       setTimeout(function(){
           search.focus();
        },50)
                  }
      if(phoneInput.value == '' && flagIcon.style.display == 'none'){
        document.querySelector('#wsaioi_formphonedropdown').style.display = 'block';
      } 
      reset_phone_error();
              });

    phoneInput.addEventListener('keypress', function (e) {
      if (!/[0-9+]/.test(e.key)) {
        e.preventDefault();
      }
    });

    phoneInput.addEventListener("blur", (e) => {
       if (flagIcon.style.display == 'none') {
        return; 
      }
      try {
        let phone_value = phoneInput.value.trim();
        phoneInput.value = phone_value.replace(/[^+\d]/g, '');
        if (phone_value.startsWith('00')) {
          phone_value = '+' + phone_value.slice(2);
          phoneInput.value = phone_value;
        }
		    if(phone_value == '') return;
        if (!phone_value.startsWith('+')) {
              var country_code = flagIcon.getAttribute('data-code');
              var ccDigits = country_code.replace('+', '');  

              if (phone_value.startsWith('0')) {
                phone_value = phone_value.substring(1);
              }
              if (!phone_value.startsWith(ccDigits)) {
                phone_value = ccDigits + phone_value;
              }

            phone_value = '+' + phone_value;
          }
        var code_found = false;
        var ggy = wsaio_phonecountries.forEach(function(cd) {
          if (phone_value.indexOf('+' + cd.dialCode) > -1) {
            var g = phone_value.replace('+' + cd.dialCode, '');
            g = g.replace(/\\+/g, '');
g = g.replace(/^0+/, '');
            phoneInput.value = '+' + cd.dialCode + g;
               code_found = true;
            }
              });
        if(!code_found){
               var ggy = (phone_value).replace(/^0+/, '');
               phoneInput.value = ggy;
      }
          if(!code_found && phoneInput.value != '' && document.querySelector('[name="address[phone]"]').previousElementSibling.getAttribute('data-code') != null){
            phoneInput.value = document.querySelector('[name="address[phone]"]').previousElementSibling.getAttribute('data-code')+phoneInput.value;
    }
        const number = libphonenumber.parsePhoneNumberFromString(phoneInput.value);
        if(number && number.country) {
          const found = wsaio_phonecountries.find(c => c.code === number.country);
          if(found) setCountry(found, false);
        }else{
           reset_phone_error();
           if(flagIcon.style.display != 'none'){
                document.querySelector('.wsaio_phonewrapper').insertAdjacentHTML("afterend",'<span class="waio--customer-phone-error" style="color: red; display: block; font-style: italic;">Please enter a valid phone number</span>');
           }
       }
        validatePhone();
      } catch(e) {console.log(e)
        reset_phone_error();
      }
    });

    function isAllowedCountry(countryCode) {
      return countriesToRender.some(c => c.code === countryCode);
            }

    function validatePhone() {
  
      try {
        if(currentCountry != undefined){
          const number = libphonenumber.parsePhoneNumberFromString(phoneInput.value, currentCountry.code);
          reset_phone_error();
          if(number && number.isValid() && isAllowedCountry(number.country) && number.country === currentCountry.code) {
          } else {
              document.querySelector('.wsaio_phonewrapper').insertAdjacentHTML("afterend",'<span class="waio--customer-phone-error" style="color: red; display: block; font-style: italic;">Please enter a valid phone number</span>');
    }
        }
      } catch(e) {console.log(e)
            document.querySelector('.wsaio_phonewrapper').insertAdjacentHTML("afterend",'<span class="waio--customer-phone-error" style="color: red; display: block; font-style: italic;">Please enter a valid phone number</span>');
      }
    }

    document.addEventListener("click", function(e) {
        if (!dropdown || !document.querySelector('.wsaio_phonewrapper')) return;
        if (!dropdown.contains(e.target) && !document.querySelector('.wsaio_phonewrapper').contains(e.target)) {
            dropdown.style.display = "none";
        }
        search.value = '';
        search.dispatchEvent(new Event('input'));
    });

    setCountry(currentCountry);
}
    
   function reset_phone_error2() {
      const errors = document.querySelectorAll(".ws-registration-form--form .waio--customer-phone-error2");
      errors.forEach(el => el.remove());
   }


  WSAIO.enableCaptcha = false;
  function renderCaptcha_script(){
    if (typeof WSAIO.enableCaptcha != 'undefined' && WSAIO.enableCaptcha) {
      var script = document.createElement('script');
      script.src = 'https://js.hcaptcha.com/1/api.js';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }
  if(typeof WSAIO != 'undefined' && typeof WSAIO.enableCaptcha != 'undefined' && WSAIO.enableCaptcha && window.hcaptcha == undefined) renderCaptcha_script();
 if (document.querySelector(".ws-registration-form--form .ws-password-container") != null) {
    var passwordField_html1 = document.querySelector(".ws-registration-form--form .ws-password-container").innerHTML.replace(/readonly=""|readonly="readonly"|readonly/g, '');
    var passwordField_html2 = document.querySelector(".ws-registration-form--form .ws-password_confirmation-container").innerHTML.replace(/readonly=""|readonly="readonly"|readonly/g, '');
  }

  /* ====================[ Document Load ( END ) ]======================= */

  
  /* ====================[ login Functions ( START ) ]======================= */

 function append_login_form(){
  const targetElement = document.querySelector('.ws-registration-form--form');
    if (targetElement) {
      const loginForm = document.createElement('form');
      loginForm.className = 'custom-wsaio-login-form';
      loginForm.method = 'post';
      loginForm.action = '/account/login';
      loginForm.style.display = 'none';
      loginForm.innerHTML = '<input type="hidden" name="return_to" value="/account" /><input type="email" name="customer[email]" placeholder="Email" required /><input type="password" name="customer[password]" placeholder="Password" required /><button type="submit">Login</button>';

      targetElement.insertAdjacentElement('afterend', loginForm);
    }
  }


 function trigger_login_form(return_to,email_string,password_string){
     const targetForm = document.querySelector('.custom-wsaio-login-form');
      const newEmailInput = targetForm.querySelector('[name="customer[email]"]');
      const newPasswordInput = targetForm.querySelector('[name="customer[password]"]');
     if (email_string && password_string && newEmailInput && newPasswordInput) {
        const return_to_input = targetForm.querySelector('[name="return_to"]');
        newEmailInput.value = email_string;
        newPasswordInput.value = password_string;
        return_to_input.value = return_to;
        targetForm.submit();
     }
 }

 /* ====================[ login Functions ( END ) ]======================= */


  /* ====================[ Helper Functions ( START ) ]======================= */
  var password_string1 = '',password_string2 = '';
  var validations = {
    email: [
      /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/,
      "Please enter a valid email address"
    ]
  };

  function show_password() {
    if(document.querySelector(".ws-registration-form--form .ws-password-container") != null){
        document.querySelector(".ws-registration-form--form .ws-password-container").innerHTML = passwordField_html1;
        document.querySelector(".ws-registration-form--form .ws-password_confirmation-container").innerHTML = passwordField_html2;
        document.querySelector('.ws-registration-form--form [name="customer[password]"]').value = password_string1;
        document.querySelector('.ws-registration-form--form [name="customer[password_confirmation]"]').value = password_string2;
    }
  }

  function hide_password() {
    if(document.querySelector(".ws-registration-form--form .ws-password-container") != null){
        document.querySelector(".ws-registration-form--form .ws-password-container").innerHTML = "";
        document.querySelector(".ws-registration-form--form .ws-password_confirmation-container").innerHTML = "";
    }
  }

let wsaioIntervalID;
var maxIntervalTime = 5000;
var currentInterval = 0;
var parmanent_password_hide = false;
function waitForFunction() {
    currentInterval = currentInterval + 50;
    if(currentInterval >= maxIntervalTime)  clearInterval(wsaioIntervalID);
    if(typeof window.wsaio_account_url != 'undefined' && window.wsaio_account_url){
        clearInterval(wsaioIntervalID);
        if(window.wsaio_account_url.indexOf('/login') == -1){
            parmanent_password_hide = true;
            hide_password();
        }
     }
}
wsaioIntervalID = setInterval(waitForFunction, 50);

  function check_password_validate(event){
  var pw1 = document.querySelector('.ws-registration-form--form [name="customer[password]"]').value;
  var pw2 = document.querySelector('.ws-registration-form--form [name="customer[password_confirmation]"]').value;
    password_string1 = pw1;
    password_string2 = pw2;
    function remove_error(){
      if (document.querySelector(".ws-registration-form--form .password_space_error") != null) {
            var remove_error = document.querySelectorAll(".ws-registration-form--form .password_space_error");
            for(i=0;i<remove_error.length;i++){
              remove_error[i].remove();
            }
        }
    }
if((/^\\s/).test(event.target.value)){
       remove_error();
       if (document.querySelector(".ws-registration-form--form .password_error") == null) {
            document.querySelector('.ws-registration-form--form [name="customer[password]"]').insertAdjacentHTML(
            "afterend",
           '<span class=".ws-registration-form--form password_space_error" style="color: red; display: block; font-style: italic;">Space not allowed in password</span>'
          );
         }
    }else{
       if(pw1 != "" && pw2 != ""){
     if((/^\\s/).test(pw1) != true && (/^\\s/).test(pw2) != true){
           remove_error();
         }
       }else{
           remove_error();
       }
    }

     if (pw1 == pw2 && pw1 != "" && pw2 != "") {
        if (document.querySelector(".ws-registration-form--form .password_error") != null) {
          var node = document.querySelector(".ws-registration-form--form .password_error");
          if (node.parentNode) {
            node.parentNode.removeChild(node);
          }
        }
     }

     function remove_MaxLength_error(){
           if (document.querySelector(".ws-registration-form--form .password_maxLength_error") != null) {
             var remove_error = document.querySelectorAll(".ws-registration-form--form .password_maxLength_error");
             for(i=0;i<remove_error.length;i++){
               remove_error[i].remove();
             }
         }
     }

     var maxLength___exceed = false;
     if(pw1 != '' && pw1.length > 40){
       maxLength___exceed = true;
     }
     if(pw2 != '' && pw2.length > 40){
       maxLength___exceed = true;
    }
     if(maxLength___exceed){
         remove_MaxLength_error();
         remove_error();
     if (document.querySelector(".ws-registration-form--form .password_error") != null) {
             var node = document.querySelector(".ws-registration-form--form .password_error");
             if (node.parentNode) {
               node.parentNode.removeChild(node);
             }
           }
         if (document.querySelector(".ws-registration-form--form .password_maxLength_error") == null) {
             document.querySelector('.ws-registration-form--form [name="customer[password]"]').insertAdjacentHTML(
             "afterend",
             '<span class="password_maxLength_error" style="color: red; display: block; font-style: italic;">Maximum 40 character allowed.</span>'
           );
         }
     }else{
         if (document.querySelector(".ws-registration-form--form .password_maxLength_error") != null) {
           remove_MaxLength_error();
         }
    }
  }

  function check_password_space(){
    var pw1 = document.querySelector('.ws-registration-form--form [name="customer[password]"]').value;
    var pw2 = document.querySelector('.ws-registration-form--form [name="customer[password_confirmation]"]').value;
    if(pw1 != "" && pw2 != ""){
  if((/^\\s|\\s$/).test(pw1) == true || (/^\\s|\\s$/).test(pw2) == true){
    if (document.querySelector(".ws-registration-form--form .password_space_error") != null) {
      var remove_error = document.querySelectorAll(".ws-registration-form--form .password_space_error");
      for(i=0;i<remove_error.length;i++){
        remove_error[i].remove();
      }
  }
          if (document.querySelector(".password_error") == null) {
             document.querySelector('.ws-registration-form--form [name="customer[password]"]').insertAdjacentHTML(
             "afterend",
             '<span class="password_space_error" style="color: red; display: block; font-style: italic;">Space not allowed in password</span>'
           );
          }
         return true;
      }
    }
}
            
  function remove_password_error() {
    if (document.querySelector(".password_error") != null) {
      var node = document.querySelector(".password_error");
      if (node.parentNode) {
        node.parentNode.removeChild(node);
      }
    }
  var pw1 = document.querySelector('.ws-registration-form--form [name="customer[password]"]').value;
  var pw2 = document.querySelector('.ws-registration-form--form [name="customer[password_confirmation]"]').value;
  if(pw1 != "") pw1 = pw1.trim();
  if(pw2 != "")pw2 = pw2.trim();
   if (pw1 != pw2 && pw1 != "" && pw2 != "" && document.querySelector(".password_space_error") == null && document.querySelector(".password_maxLength_error") == null) {
      document.querySelector('.ws-registration-form--form [name="customer[password]"]').insertAdjacentHTML(
        "afterend",
        '<span class="password_error" style="color: red; display: block; font-style: italic;">Password and confirm password do not match</span>'
      );
    }
  }

  function remove_email_error() {
    if (document.querySelector(".email_error") != null) {
      var node = document.querySelector(".email_error");
      if (node.parentNode) {
        node.parentNode.removeChild(node);
      }
    }
  }

  function isObjectEmpty(value) {
    return (Object.prototype.toString.call(value) === "[object Object]" && JSON.stringify(value) === "{}");
  }

  /* ====================[ Helper Functions ( END ) ]======================= */

  /* Encapsulating core methods */
  (function(){

    /* ====================[ Helper Prototypes ( Start ) ]======================= */
    Element.prototype.trigger=function(type){
      var elem = this;
      var event = document.createEvent("MouseEvents");
      event.initMouseEvent(type, true, true, elem.ownerDocument.defaultView,
                           0, 0, 0, 0, 0, false, false, false, false, 0, null);
      elem.dispatchEvent( event );
    }
    HTMLFormElement.prototype.serialize = function() {

      /* Fetching form elements */
      var elemArray = this.elements;
      /* Generating data from elements */
      var formObj = {};
      for (var item in elemArray) {
        var input = elemArray[item];
        if (!input || !input.name) continue;
        if(typeof input.type !== "undefined" && (input.type === "checkbox" || input.type === "radio") ){
          if(input.checked) formObj[input.name] = input.value;
        }
        else formObj[input.name] = input.value;  

      }
      /* converting json to url encoded string */
      return Object.keys(formObj).map(function(k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(formObj[k])
      }).join('&');
    }
    /* ====================[ Helper Prototypes ( END ) ]======================= */


    /* ====================[ Event Listeners (START) ]======================= */

    const url_fields = document.querySelectorAll('input[type="url"]');
    if(url_fields.length > 0){
      for(var i=0; i<url_fields.length; i++){
        url_fields[i].addEventListener('focusout', function (event)  {
          if(event.target.value && event.target.value !== '' && event.target.value.includes("https://") === false && event.target.value.includes("http://") === false){
            event.target.value = 'https://'+event.target.value;
          }
        });
      }
    }

    var countryEl = document.getElementById("waio--address_country");
    if (countryEl) {
      countryEl.addEventListener("change", function (e) {
        var provinceEl = document.getElementById("waio--address_province");
        countryEl = e.target;

        if (countryEl.selectedIndex === 0) {
          provinceEl.parentNode.style.display = "none";
          return;
        }
        function removeAllChildNodes(parent) {
          while (parent.firstChild) {
              parent.removeChild(parent.firstChild);
          }
        }
        removeAllChildNodes(provinceEl);

        countryOps = [];
        if(countryEl.selectedIndex > 0){
          countryOps = JSON.parse(countryEl.options[countryEl.selectedIndex].getAttribute("data-provinces"));
        }

        if (provinceEl) {
          var i = -1,children = provinceEl.childNodes;

          while (++i < children.length) {
            provinceEl.removeChild(children[i]);
          }

          if(countryOps.length > 0){
            provinceEl.parentNode.style.display = "inline-block";
            for (var b = 0; b < countryOps.length; b++) {
              var option = document.createElement("option");
              option.value = countryOps[b][0];
              option.innerHTML = countryOps[b][1];
              provinceEl.appendChild(option);
            }
          }
          else {
            provinceEl.parentNode.style.display = "none";
          }


        } else {
          provinceEl.parentNode.style.display = "none";
        }
      });
      countryEl.value = document.getElementById("waio--address_country").value;
      countryEl.trigger("change");
    }

     var phoneSelector = document.querySelector('.ws-registration-form--form [name="address[phone]"]');
   var emailselector = document.querySelector('.ws-registration-form--form [name="customer[email]"]');
   if(phoneSelector && emailselector){
     document.querySelector('.ws-registration-form--form  [name="address[phone]"]').addEventListener("focusout", function (e) {
         var input_value = e.target.value;
         var email_value = emailselector.value;
          if (!input_value || input_value.length === 0 || input_value == '' || email_value == '' || !email_value) {
             reset_phone_error2();
             return;
          }
          const encodedPhone = encodeURIComponent((phoneSelector.value).replace(/[\\s\\-\\(\\)]/g, ''));
          var Url = "https://wholesales.digitalcoo.com/admin/api/2021-03/query?id=29490000-5774-41fc-9813-c0fda1b74380&shop=andersen-hitches.myshopify.com&phone=" + encodedPhone + "&email=" + email_value;
          var data_method = {
           headers: {
              "X-Ws-Shop-Domain": "andersen-hitches.myshopify.com",
              "X-Ws-Shop-Token": "c5c256c0-f56d-4cd2-8991-25734552b555",
              "X-Ws-Form-Id": "29490000-5774-41fc-9813-c0fda1b74380"
            }
          };
          var xhr = new XMLHttpRequest();
          xhr.open('GET', Url, true);
          xhr.setRequestHeader("X-Ws-Shop-Domain", data_method.headers["X-Ws-Shop-Domain"]);
          xhr.setRequestHeader("X-Ws-Shop-Token", data_method.headers["X-Ws-Shop-Token"]);
          xhr.setRequestHeader("X-Ws-Form-Id", data_method.headers["X-Ws-Form-Id"]);
          xhr.onreadystatechange = function() {
          if (xhr.readyState == 4) { //XMLHttpRequest.DONE
              var success = JSON.parse(xhr.responseText);
              reset_phone_error2();
              if(success && success.phoneMatchesWith && success.phoneMatchesWith != null && success.phoneMatchesWith.email){
                var email_string = success.phoneMatchesWith.email;
                 if(email_string.indexOf('***') > -1){
                    if(document.querySelector(".ws-registration-form--form .wsaio_phonewrapper") != null){
                       document.querySelector('.ws-registration-form--form .wsaio_phonewrapper').insertAdjacentHTML(
                         "afterend",
                         '<span class="waio--customer-phone-error2" style="color: red; display: block; font-style: italic;margin: 4px 0 !important; display: block; letter-spacing: 1px !important; font-size: small !important; padding-bottom: 0 !important; line-height: inherit !important; font-weight: initial !important; text-align: left;">Phone number already linked to '+email_string+'</span>'
                       );
                    }
                    }
              }

          }
          }
          xhr.send(null);
     })
  }


   if(emailselector){
       emailselector.addEventListener("change", function (e) {
        var input_value = e.target.value;

  
        if (!input_value || input_value.length === 0) {
       if (document.querySelector(".ws-registration-form--form  .ws-password-container") != null && document.querySelector(".ws-registration-form--form  .ws-password-container").innerHTML == '' && !parmanent_password_hide) {
            show_password();
          }

          remove_email_error();
          return;
        }

        validation = new RegExp(validations["email"][0]);

        if (!validation.test(input_value)) {
          this.setCustomValidity(validations["email"][1]);

          remove_email_error();

          document.querySelector('.ws-registration-form--form [name="customer[email]"]')
          .insertAdjacentHTML(
            "afterend",
            '<span class="email_error" style="color: red; display: block; font-style: italic;">Please enter a valid email address</span>'
          );

          if (document.querySelector(".email_error") != null) {
            document.querySelector(".email_error").scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest"
            });
          }

          return false;
        } else {

          this.setCustomValidity("");
        }

        var Url_request = "https://wholesales.digitalcoo.com/admin/api/2021-03/query?id=29490000-5774-41fc-9813-c0fda1b74380&shop=andersen-hitches.myshopify.com&email=" + input_value;

       if(phoneSelector){
          phone_value = phoneSelector.value;
          if (phone_value && phone_value.length != 0 || phone_value != '') {
            const encodedPhone = encodeURIComponent((phoneSelector.value).replace(/[\\s\\-\\(\\)]/g, ''));
              Url_request =  "https://wholesales.digitalcoo.com/admin/api/2021-03/query?id=29490000-5774-41fc-9813-c0fda1b74380&shop=andersen-hitches.myshopify.com&email=" + input_value + "&phone=" + encodedPhone; 
          }
         
       }

       var Url = Url_request;
        var data_method = {
          headers: {
            "X-Ws-Shop-Domain": "andersen-hitches.myshopify.com",
            "X-Ws-Shop-Token": "c5c256c0-f56d-4cd2-8991-25734552b555",
            "X-Ws-Form-Id": "29490000-5774-41fc-9813-c0fda1b74380"
          }
        };
        var xhr = new XMLHttpRequest();
        xhr.open('GET', Url, true);
        xhr.setRequestHeader("X-Ws-Shop-Domain", data_method.headers["X-Ws-Shop-Domain"]);
        xhr.setRequestHeader("X-Ws-Shop-Token", data_method.headers["X-Ws-Shop-Token"]);
        xhr.setRequestHeader("X-Ws-Form-Id", data_method.headers["X-Ws-Form-Id"]);
        xhr.onreadystatechange = function() {
          if (xhr.readyState == 4) { //XMLHttpRequest.DONE
            var success = JSON.parse(xhr.responseText);
         if (success && success.state && success.state == 'enabled') {
             if (document.querySelector(".ws-registration-form--form  .ws-password-container") != null) {
                hide_password();
              }
            } else {
           if (document.querySelector(".ws-registration-form--form  .ws-password-container") != null && document.querySelector(".ws-registration-form--form  .ws-password-container").innerHTML == '' && !parmanent_password_hide) {
                show_password();
             }
           }
           reset_phone_error2();
           if(success && success.phoneMatchesWith && success.phoneMatchesWith != null && success.phoneMatchesWith.email){
                var email_string = success.phoneMatchesWith.email;
                 if(email_string.indexOf('***') > -1){
                    if(document.querySelector(".ws-registration-form--form .wsaio_phonewrapper") != null){
                       document.querySelector('.ws-registration-form--form .wsaio_phonewrapper').insertAdjacentHTML(
                         "afterend",
                         '<span class="waio--customer-phone-error2" style="color: red; display: block; font-style: italic;margin: 4px 0 !important; display: block; letter-spacing: 1px !important; font-size: small !important; padding-bottom: 0 !important; line-height: inherit !important; font-weight: initial !important; text-align: left;">Phone number already linked to '+email_string+'</span>'
                       );
                    }
              }
            }

          }
        }
        xhr.send(null);

      });
    }


    function check_hcaptcha(){
      var allow_submition = true;
        if(document.querySelector('[data-hcaptcha-response]') != null){
            if(document.querySelector('[data-hcaptcha-response]').getAttribute('data-hcaptcha-response') != ''){
                allow_submition = true;
            }else{
                allow_submition = false;
              document.querySelector(".ws-registration-form--form .h-captcha").insertAdjacentHTML( "afterend", '<div class="waio--customer-created-msg hcaptcha"><div aria-live="assertive" role="alert" id="shouter" tabindex="0" class="waio--error-message" style="width: fit-content !important;"> Please complete the CAPTCHA to proceed.</div></div>');
              if(document.querySelector('.ws-registration-form--form .h-captcha') != null && document.querySelector('.waio--customer-created-msg.hcaptcha') != null){
                  setTimeout(function(){document.querySelector('.waio--customer-created-msg.hcaptcha').remove()},3000)
              }
           }
        }
       return allow_submition;
    }

    const sub_btn = document.getElementById('wsaui-submit-btn');
    const newsub_btn = sub_btn.cloneNode(true);
    sub_btn.parentNode.replaceChild(newsub_btn, sub_btn);
    var form = document.querySelector(".ws-registration-form--form");
    let isRequestInProgress = false;
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (isRequestInProgress) {
                return;
        }
      var _this = this;
      setTimeout(function(){
        if(document.querySelector('.ws-registration-form--form [name="customer[password]"]') != null){
          var check_password_spaces = check_password_space();
          if(check_password_spaces){
            document.querySelector('.ws-registration-form--form [name="customer[password]"]').scrollIntoView({ behavior: "smooth", block: "center" }); return;
          }
       }

      if(document.querySelector('.ws-registration-form--form  .password_space_error') != null || 
          document.querySelector('.ws-registration-form--form  .password_maxLength_error') != null || 
          document.querySelector('.ws-registration-form--form  .password_error') != null
     ){ 
         document.querySelector('.ws-registration-form--form [name="customer[password]"]').scrollIntoView({ behavior: "smooth", block: "center" }); return;
      }
      if(document.querySelector('.ws-registration-form--form  .email_error') != null){ 
         document.querySelector('.ws-registration-form--form [name="customer[email]"]').scrollIntoView({ behavior: "smooth", block: "center" }); return;
      }
       
    if(document.querySelector('.ws-registration-form--form  .waio--customer-phone-error2') != null){
         phoneSelector.scrollIntoView({
         behavior: "smooth", 
         block: "center"  
       });
        return;
      }
   
     if(document.querySelector('.ws-registration-form--form  .waio--customer-phone-error') != null){
          phone_input.scrollIntoView({
          behavior: "smooth", 
          block: "center"  
        });
         return;
      }else{
        var phone_field = document.querySelector('.ws-registration-form--form [name="address[phone]"]');
         var number_code_element = document.querySelector('.iti__a11y-text');
          if (phone_field != null && number_code_element != null) {
              var number_val = phone_field.value;
              var number_code = number_code_element.getAttribute('dialCode');
              if (number_code != null && !number_val.startsWith(number_code)) {
                  phone_field.value = number_code + number_val;
              }
          }
      }

        if(typeof WSAIO.enableCaptcha != 'undefined' && WSAIO.enableCaptcha && !check_hcaptcha()) return;
        document.getElementById('wsaui-submit-btn').style.cursor = 'progress';
     const submitButton = _this.querySelector('input[type="submit"]');
        submitButton.disabled = true;
        if(document.querySelector(".wsaio_bot_check") != null && document.querySelector(".wsaio_bot_check").value != ''){
          if (document.querySelector(".waio--customer-created-msg") != null) {
                  var node = document.querySelector(".waio--customer-created-msg");
                  node.parentNode.removeChild(node);
           }
           document.querySelector(".ws-registration-form--form").insertAdjacentHTML( "afterend", '<div class="waio--customer-created-msg"><div aria-live="assertive" role="alert" id="shouter" tabindex="0" class="waio--error-message">We are sorry, you can not submit this form for now. Our spam blocker tool has detected you as a bot.</div></div>');
        }else{
        var action = "https://wholesales.digitalcoo.com/admin/api/2021-03/signup?id=29490000-5774-41fc-9813-c0fda1b74380&shop=andersen-hitches.myshopify.com&token=c5c256c0-f56d-4cd2-8991-25734552b555";
        e.preventDefault();
        var data_method = {
          method: "POST",
          headers: {
            "X-Ws-Shop-Domain": "andersen-hitches.myshopify.com",
            "X-Ws-Shop-Token": "c5c256c0-f56d-4cd2-8991-25734552b555",
            "X-Ws-Form-Id": "29490000-5774-41fc-9813-c0fda1b74380"
          }
        };

      if(typeof WSAIO != 'undefined' && typeof WSAIO.enable_auto_login != 'undefined' && WSAIO.enable_auto_login){
            append_login_form();
        }

        var xhr1 = new XMLHttpRequest();
      // var params = _this.serializeArray(); // customer prototype
         const myFormData = new FormData(e.target);
         let params = [];
          myFormData.forEach(function(value, key){
            var foundIndex = params.findIndex(function(v){return v.key === key});
            if(foundIndex > -1){
               var update_key = key.replace("]", "_".repeat(params[foundIndex].count)+']');
               params.push({
                 key: update_key,
                 value: value,
                 count:1
               });
              params[foundIndex].count++;
            }else{
               params.push({
                    key: key,
                 value: value,
                 count:1
               });
            }
        });
        let newParam = {};
        if(Shopify != undefined && Shopify.routes != undefined && Shopify.routes.root !== '/'){
            params.push({
                    key: 'customer_locale',
                    value: Shopify.locale,
                    count:1
               });
        }
        params.forEach(function(pItem){newParam[pItem.key]=pItem.value})
        xhr1.open('POST', action, true);

        //Send the proper header information along with the request
        xhr1.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr1.setRequestHeader("X-Ws-Shop-Domain", data_method.headers["X-Ws-Shop-Domain"]);
        xhr1.setRequestHeader("X-Ws-Shop-Token", data_method.headers["X-Ws-Shop-Token"]);
        xhr1.setRequestHeader("X-Ws-Form-Id", data_method.headers["X-Ws-Form-Id"]);
        xhr1.onreadystatechange = function() {
          if(typeof WSAIO.enableCaptcha != 'undefined' && WSAIO.enableCaptcha && window.hcaptcha != undefined){
            window.hcaptcha.reset();
          }
          if (xhr1.readyState == 4) { //XMLHttpRequest.DONE
            var success = JSON.parse(xhr1.responseText);
            submitButton.disabled = false;
            isRequestInProgress = false; 
            document.getElementById('wsaui-submit-btn').style.cursor = 'pointer';
            if (success.status == 2) {
              if (success.account == "already exists") {
                var el = document.getElementById("waio--address_country");

                if (el) {
                  el.value = document.getElementById("waio--address_country").value;
                  el.trigger('change');
                }

                if (
                  document.querySelector(".waio--customer-created-msg") != null
                ) {
                  var node = document.querySelector(".waio--customer-created-msg");
                  node.parentNode.removeChild(node);

                }

                document.querySelector(".ws-registration-form--form").insertAdjacentHTML(
                  "afterend",
                  '<div class="waio--customer-created-msg"><div aria-live="assertive" role="alert" id="shouter" tabindex="0" class="waio--error-message">' + success.message + "</div></div>"
                );

              } else {
                if (document.querySelector(".ws-registration-form--form .password_error") != null) {
                  var node = document.querySelector(".ws-registration-form--form .password_error");
                  node.parentNode.removeChild(node);
                }

               if (document.querySelector(".ws-password-container") != null) {
                 document.querySelector('.ws-registration-form--form  [name="customer[password_confirmation]"]')
                  .insertAdjacentHTML(
                    "afterend",
                    '<span class="password_error" style="color: red; display: block; font-style: italic;">' +
                    success.message +
                    "</span>"
                  );
                 document.querySelector(".ws-registration-form--form  .password_error").scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest"
                  });
                }
              }
            } else if (success.status == 1) {
            const sourceForm = document.querySelector('.ws-registration-form--form');
            const sourceEmailInput = sourceForm?.querySelector('[name="customer[email]"]');
            const sourceEmailPassword = sourceForm?.querySelector('[name="customer[password]"]');
            var email_string = '';
            var password_string = '';
            if(sourceEmailInput && sourceEmailPassword){
             email_string =  sourceEmailInput.value;
             password_string = sourceEmailPassword.value;
            }

              document.querySelector(".ws-registration-form--form").reset();
              var el = document.getElementById("waio--address_country");

              if (el) {
                el.value = document.getElementById("waio--address_country").value;
                el.trigger('change');
              }

              if (document.querySelector(".waio--customer-created-msg") != null) {

                var node = document.querySelector(".waio--customer-created-msg");
                node.parentNode.removeChild(node);
              }

              document.querySelector(".ws-registration-form--form")
              .insertAdjacentHTML(
                "afterend",
                '<div class="waio--customer-created-msg"><div aria-live="assertive" role="alert" id="shouter" tabindex="0" class="waio--success-message">' + success.message + "</div></div>"
              ); 

// Redirect to url if specified
             if ( typeof success.wholesale_form !== "undefined" && success.wholesale_form ) {
               if(success.wholesale_form.approval_type == 'auto' && typeof WSAIO.enable_auto_login != 'undefined' && WSAIO.enable_auto_login && email_string != '' && password_string != ''){
                    var customer_redirect_url = false;
                     if(success.wholesale_form.customer_redirect_url_checkbox === true && success.wholesale_form.customer_redirect_url !== ""){
                        customer_redirect_url = success.wholesale_form.customer_redirect_url;
                     }else{
                        customer_redirect_url = '/account';
                     }
                             trigger_login_form(customer_redirect_url,email_string,password_string);
               }else{
                 if ( success.wholesale_form.customer_redirect_url_checkbox === true && success.wholesale_form.customer_redirect_url !== "" ) {
                   // wait for some time so customer can alteast read the success message
                   setTimeout(function(){
                     let redirect_url = success.wholesale_form.customer_redirect_url;
                     if(redirect_url.includes("http") === false && redirect_url.includes("https") === false){
                       redirect_url = "https://"+redirect_url;
                     }
                     window.location.href = redirect_url;
                   }, 4000);
                 }
               }
            
             }
            }

          }
        }
        xhr1.send(new URLSearchParams(newParam).toString());
      }
  },1000);
      });
    }
    /* ====================[ Event Listeners ( END ) ]======================= */

   WSAIO.wsf_translate_json = [
     {
         "ws--greeting_message_default": {
           "es" : "¡Solicite una cuenta mayorista y comience a ahorrar hoy!",
           "it":"Richiedi un conto all'ingrosso e inizia a risparmiare oggi!",
           "pt-PT":"Inscreva-se para uma conta de atacado e comece a economizar hoje!",
           "fr":"Demandez un compte de gros et commencez à économiser dès aujourd'hui !",
           "de":"Vraag een groothandelsaccount aan en begin vandaag nog met besparen!"
         }
     },
     {
         "ws--login_text_default": {
           "es" : "¿Ya tienes una cuenta?",
           "it":"Hai già un account?",
           "pt-PT":"já tem uma conta?",
           "fr":"Vous avez déjà un compte?",
           "de":"Heeft u al een account?"
         }
       },
       {
         "ws--login_link_default": {
           "es" : "Entre aquí",
           "it":"Accedi qui",
           "pt-PT":"Entre aqui",
           "fr":"Connectez-vous ici",
           "de":"Hier inloggen"
         }
       },
     {
       "ws--first_name": {
         "es" : "Nombre",
         "it":"Nome",
         "pt-PT":"Nome",
         "fr":"Nom",
         "de":"Vorname"
       }
     },
     {
       "ws--last_name": {
         "es" : "Apellido",
         "it":"Cognome",
         "pt-PT":"Sobrenome",
         "fr":"Prenom",
         "de":"Nachname"
       }
     },
     {
       "ws--email": {
         "es" : "Email",
         "it":"Email",
         "pt-PT":"Email",
         "fr":"Adresse e-mail",
         "de":"E-Mail"
       }
     },
     {
       "ws--company_name": {
         "es" : "Nombre de la Empresa",
         "it":"Nome della Compagnia",
         "pt-PT":"Nome da empresa",
         "fr":"Raison Sociale",
         "de":"Firmenname"
       }
     },
     {
       "ws--phone_number": {
         "es" : "Número de teléfono",
         "it":"Numero di Telefono",
         "pt-PT":"Número de Telefone",
         "fr":"Téléphone",
         "de":"Telefonnummer"
       }
     },
     {
       "ws--alternative_phone_number_optional": {
         "es" : "Número de teléfono alternativo (opcional)",
         "it":"Numero di Telefono Alternativo (Opzionale)",
         "pt-PT":"Número de Telefone Alternativo (opcional)",
         "fr":"Numéro de téléphone alternatif (facultatif)",
         "de":"Alternative Telefonnummer (optionale)"
       }
     },
     {
       "ws--tax_idabnvat_number": {
         "es" : "Número NIF/ CIF/ VAT",
         "it":"Numero di Partita IVA",
         "pt-PT":"Número CIF/ NIF/ IVA",
         "fr":"Numéro TVA/ SIRET/ VAT",
         "de":"Nummer Ust.ID/VAT"
       }
     }, 
     {
       "ws--website": {
         "es" : "Sitio Web",
         "it":"Pagina Web",
         "pt-PT":"Página Web",
         "fr":"Le Site Web",
         "de":"Webseite"
       }
     }, 
     {
       "ws--password": {
         "es" : "Contraseña",
         "it":"Password",
         "pt-PT":"Palavra-Passe",
         "fr":"Mot de Passe",
         "de":"Passwort"
       }
     },
     {
       "ws--password_confirmation": {
         "es" : "Confirmación de Contraseña",
         "it":"Conferma Password",
         "pt-PT":"Confirmar Palavra-Passe",
         "fr":"Confirmation Mot de Passe",
         "de":"Passwort Wiederholen"
       }
     },
     {
       "ws--business_info_default": {
         "es" : "Cuéntenos un poco sobre usted para que podamos verificar su identidad comercial.",
         "it":"Raccontaci qualcosa di te in modo che possiamo verificare l'identità della tua azienda",
         "pt-PT":"Conte-nos um pouco sobre você para que possamos verificar a identidade da sua empresa",
         "fr":"Parlez-nous un peu de vous afin que nous puissions vérifier l'identité de votre entreprise",
         "de":"Vertel ons iets over uzelf, zodat we uw bedrijfsidentiteit kunnen verifiëren"
       }
     },
     {
       "ws--customer_information": {
         "es" : "Información al cliente",
         "it":"Informazioni sul cliente",
         "pt-PT":"Informação ao Cliente",
         "fr":"Informations client",
         "de":"Klant informatie"
       }
     },
     {
       "ws--shipping_address": {
         "es" : "Dirección de Envío",
         "it":"Indirizzo di invio",
         "pt-PT":"Endereço para envio",
         "fr":"Adresse de Livraison",
         "de":"Lieferanschrift"
       }
     },
     {
       "ws--address1": {
         "es" : "Dirección1",
         "it":"Indirizzo 1",
         "pt-PT":"Endereço 1",
         "fr":"Adresse 1",
         "de":"Adresszeile 1"
       }
     },
     {
       "ws--address2": {
         "es" : "Dirección2",
         "it":"Indirizzo 2",
         "pt-PT":"Endereço 2",
         "fr":"Adresse 2",
         "de":"Adresszeile 2"
       }
     },
     {
       "ws--city": {
         "es" : "Ciudad",
         "it":"Cittá",
         "pt-PT":"Cidade",
         "fr":"Ville",
         "de":"Stadt"
       }
     },
     {
       "ws--country": {
         "es" : "País",
         "it":"Paese",
         "pt-PT":"País",
         "fr":"Pays",
         "de":"Land"
       }
     },
     {
      "ws--stateprovince": {
           "es" : "Provincia del estado",
           "it":"Stato/Provincia",
           "pt-PT":"Estado/Província",
           "fr":"État/Province",
           "de":"Staat/Provincie"
         }
     },
     {
       "ws--zippostal_code": {
         "es" : "Código Postal",
         "it":"Codice Postale",
         "pt-PT":"Código Postal",
         "fr":"Code Postal",
         "de":"Postleitzahl"
       }
     },
     {
       "ws--wsaio-submit-btn": {
         "es" : "Solicite una Cuenta",
         "it":"Click per procedere",
         "pt-PT":"Solicite uma Conta",
         "fr":"Demander un compte",
         "de":"Kundendaten Abschicken"
       }
     },
      {
       "id_waio--address_country": {
         "es" : "Seleccione un país",
         "it":"Seleziona un Paese",
         "pt-PT":"Selecione um pais",
         "fr":"Choisissez un pays",
         "de":"Selecteer een land"
       }
     },
     {
       "ws--fileupload": {
         "es" : "Subir archivo",
         "it":"upload di file",
         "pt-PT":"upload de arquivo",
         "fr":"téléchargement de fichiers",
         "de":"bestand upload"
       }
     },
     {
       "ws--marketing_emails_default": {
         "es" : "Acepto recibir correos electrónicos promocionales",
         "it":"Accetto di ricevere email promozionali",
         "pt-PT":"Concordo em receber e-mails promocionais",
         "fr":"J'accepte de recevoir des emails promotionnels",
         "de":"Ik ga akkoord met het ontvangen van promotionele e-mails"
       }
     },
     {
       "ws--terms_and_conditions_default": {
         "es" : "Acepto los términos y condiciones",
         "it":"Accetto i Termini e le Condizioni",
         "pt-PT":"Eu aceito os termos e condições",
         "fr":"J'accepte les termes et conditions",
         "de":"Ik accepteer de algemene voorwaarden"
       }
     }       
   ];
 
   WSAIO.wsf_translate = function(param){
     for(var i = 0;i < WSAIO.wsf_translate_json.length; i++ ){
         var element_selector = Object.keys(WSAIO.wsf_translate_json[i])[0].toString();
         var element_translation = WSAIO.wsf_translate_json[i][element_selector]
         if(typeof element_translation == 'object' && Object.keys(element_translation).length !== 0 && element_translation[param] != undefined){
                 var selector = document.querySelector('.'+element_selector);
                 if(selector != null){ selector.innerHTML = element_translation[param]; }
      
                 if(selector != null && selector.parentElement.tagName == 'LABEL' && selector.parentElement.nextSibling != null && selector.parentElement.nextSibling.type != undefined){
                     selector.parentElement.nextSibling.setAttribute('placeholder',element_translation[param])
                 }
                 if(selector != null && selector.type == 'submit'){
                     selector.setAttribute('value',element_translation[param])
                 }
         }
     }
   }
 
 WSAIO.wsf_edit_translate = function(obj){
     for(var i=0; i<obj.length;i++){
         WSAIO.wsf_translate_json.find(function(e){
             if(obj[i].key != '' && obj[i].lang != '' && obj[i].text != ''){ 
                 var json_obj = e[obj[i].key];
                 if(typeof json_obj != 'undefined'){
                     json_obj[obj[i].lang] = obj[i].text;
                 }
             }
         })
     }
     if(typeof Shopify != 'undefined' && Shopify.locale != 'undefined' && Shopify.locale != '' && WSAIO.wsf_translate != undefined){
      WSAIO.wsf_translate(Shopify.locale);
     }
     return true;
 }
 
 // Edit function example
 /*WSAIO.wsf_edit_translate([
     {
     'key':'city','lang':'fr','text':'test'
     }
 ])*/
 
 
 WSAIO.wsf_add_translation = function(obj){
         for(var i=0; i< obj.length ; i++){
             WSAIO.wsf_translate_json.push(obj[i])
         }
         if(typeof Shopify != 'undefined' && Shopify.locale != 'undefined' && Shopify.locale != '' && WSAIO.wsf_translate != undefined){
          WSAIO.wsf_translate(Shopify.locale);
         }
         return true;
 }
 

 /*  add new translation 
 WSAIO.wsf_add_translation([{
       "type--checkbox": {
         "es" : "Acepto recibir correos electrónicos promocionales",
         "it":"Accetto di ricevere email promozionali",
         "pt-PT":"Concordo em receber e-mails promocionais",
         "fr":"J'accepte de recevoir des emails promotionnels",
         "de":"Ik ga akkoord met het ontvangen van promotionele e-mails"
       }
     }])
   */

     if(typeof Shopify != 'undefined' && Shopify.locale != 'undefined' && Shopify.locale != '' && WSAIO.wsf_translate != undefined){
      WSAIO.wsf_translate(Shopify.locale);
   }
  })();
})();
`);

